import type { TFunction } from 'i18next'
import type { WorkOrderPresenter } from './workOrderPresentation'

type Presenter = Pick<WorkOrderPresenter, 'present'> & {
  subscribe?: (listener: () => void, locale?: string, texts?: string[], capture?: () => void) => () => void
}

/** One observed set of display strings, owned by the current locale and presenter. */
export function createChatDisplaySubscription(
  presenter: Presenter | undefined,
  source: string[],
  locale: string | undefined,
  translation: { current: TFunction },
) {
  const retained = new Map<string, string>()
  const capture = () => {
    if (!presenter || !locale) return
    source.forEach((value) => {
      const cached = presenter.present({ kind: 'text', value }, locale, translation.current)
      if (cached.state === 'translated') retained.set(value, cached.text)
    })
  }
  capture()
  return {
    retained,
    getSnapshot: () => JSON.stringify(source.map((value) => retained.get(value) ?? null)),
    subscribe(listener: () => void) {
      if (!presenter?.subscribe || !locale) return () => {}
      capture()
      return presenter.subscribe(() => { capture(); listener() }, locale, source, capture)
    },
  }
}
